// Calendar Range Component Handler
class CalendarRangeHandler {
  constructor() {
    this.calendar = null;
    this.target = null;
    this.init();
  }

  init() {
    document.addEventListener('turbo:load', () => {
      this.calendar = document.getElementById('range-cally-element');
      this.target = document.getElementById('range-cally-target');
      
      if (this.calendar && this.target) {
        this.setupEventListeners();
      }
    });
  }

  setupEventListeners() {
    // カレンダーの値が変更されたときの処理
    this.calendar.addEventListener('change', (e) => {
      this.updateDisplayText(e.target.value);
    });

    // グローバル関数として設定
    window.closeCalendar = this.closeCalendar.bind(this);
    window.applyDateRange = this.applyDateRange.bind(this);
  }

  updateDisplayText(value) {
    if (!value) return;
    
    const [fromDate, toDate] = value.split('/');
    const from = new Date(fromDate);
    const to = new Date(toDate);
    
    const formatDate = (date) => {
      return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
    };
    
    this.target.textContent = `${formatDate(from)} - ${formatDate(to)}`;
  }

  closeCalendar() {
    const dropdown = document.querySelector('.dropdown');
    if (dropdown) {
      dropdown.removeAttribute('open');
      dropdown.blur();
    }
  }

  applyDateRange() {
    if (!this.calendar) return;
    
    const value = this.calendar.value;
    
    if (value) {
      const [fromDate, toDate] = value.split('/');
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('fromDate', fromDate);
      currentUrl.searchParams.set('toDate', toDate);
      window.location.href = currentUrl.toString();
    }
    
    this.closeCalendar();
  }
}

// Initialize calendar handler
new CalendarRangeHandler();